import { apiFunction } from "../../apiCall/function"

export const getTokenInfo = async (code) => {
  return await apiFunction("form/verify/" + code, "get", {}, false, 'body')
}